import { Box, CircularProgress, Grid, MenuItem, TextField } from '@mui/material';
import { useCustomComponenteMakePrepaidHook } from '../hooks/actionsTicketsHooks/CustomComponenteMakePrepaidHook';

const CustomComponenteMakePrepaid = ({
  productsPrepaid,
  ActionMakePrepaid,
  ticketId,
  makePrepaid,
  listcommentsTikets,
  formData,
  onFormDataChange,
}) => {
  const {
    products,
    register,
    handleSubmit,
    handleSelectChange,
    handleCommentChange,
    onSubmit,
    loading,
    statusMessage,
    errors,
    handlePaidChange,
  } = useCustomComponenteMakePrepaidHook({
    productsPrepaid,
    ActionMakePrepaid,
    ticketId,
    makePrepaid,
    listcommentsTikets,
    formData,
    onFormDataChange,
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item size={{ xs: 12, sm: 6 }}>
          <TextField
            id='product-select'
            label='Paquetes'
            select
            variant='outlined'
            fullWidth
            defaultValue={formData?.product_id || ''}
            {...register('product_id', { required: true })}
            onChange={handleSelectChange}
            sx={{ mt: 1 }}
          >
            {products?.map((product) => (
              <MenuItem key={product.carrier_product_id} value={product.carrier_product_id}>
                {product.product_name}{' '}
              </MenuItem>
            ))}
          </TextField>

          {errors.product_id && <span style={{ color: 'red' }}>Este campo es obligatorio</span>}
        </Grid>
        <Grid item size={{ xs: 12, sm: 6 }}>
          <TextField
            id='is-paid-select'
            label='¿Comprado o regalo?'
            select
            variant='outlined'
            fullWidth
            defaultValue={formData?.is_paid || ''}
            {...register('is_paid', { required: true })}
            onChange={handlePaidChange}
            sx={{ mt: 1 }}
          >
            <MenuItem value={'true'}>Comprado</MenuItem>
            <MenuItem value={'false'}>Regalo</MenuItem>
          </TextField>

          {errors.is_paid && <span style={{ color: 'red' }}>Este campo es obligatorio</span>}
        </Grid>
        <Grid item size={{ xs: 12 }}>
          <TextField
            id='outlined-multiline-static'
            label='Comentarios'
            multiline
            rows={4}
            variant='outlined'
            defaultValue={formData?.reason || ''}
            {...register('reason', { required: true })}
            onChange={handleCommentChange}
            fullWidth
          />
          {errors.reason && <span style={{ color: 'red' }}>Este campo es obligatorio</span>}
        </Grid>
        <Grid item size={{ xs: 12 }}>
          <button type='submit'>Aplicar recarga</button>
        </Grid>
        {loading && (
          <Grid item size={{ xs: 12 }}>
            <Box display='flex' justifyContent='center' alignItems='center'>
              <CircularProgress />
            </Box>
          </Grid>
        )}
        {statusMessage && (
          <Grid item size={{ xs: 12 }}>
            <Box display='flex' justifyContent='center' alignItems='center'>
              {statusMessage}
            </Box>
          </Grid>
        )}
      </Grid>
    </form>
  );
};

export default CustomComponenteMakePrepaid;
